import { LOCAL_STORAGE_PREFIX } from 'utils/constants';
import { AB_TEST_PREFIX } from 'utils/constants/abTestSettings';
import { isKiosk } from 'utils/platform';

export const useABTest = (test: string | undefined) => {
  return {
    version: !isKiosk() && test ? localStorage.getItem(`${LOCAL_STORAGE_PREFIX}${AB_TEST_PREFIX}${test}`) : null,
  };
};
